import {
  type DatesRangeValue,
  type DateValue,
  DatePicker as MantineDatePicker,
  type DatePickerProps as MantineDatePickerProps,
} from "@mantine/dates";
import type { FieldValues } from "react-hook-form";

export type DatePickerProps = MantineDatePickerProps;

type Props<FORM_TYPE extends FieldValues> = {
  onChange?: (value: DateValue | DatesRangeValue | Date[]) => void;
} & Omit<DatePickerProps, "onChange">;

export function Calendar<FORM_TYPE extends FieldValues>(
  props: Props<FORM_TYPE>,
) {
  const { ...datePickerProps } = props;

  return <MantineDatePicker {...datePickerProps} locale={"ja"} />;
}
